// extracted by mini-css-extract-plugin
export default {"page":"GW-z","cartModal":"HW-z","checkout":"IW-z","placeholder":"JW-z","account":"KW-z"};